import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';
import cn from 'classnames';

import { Services, Table } from 'services/action';

import useTable from 'ui/components/table';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';

import tableConfig from './table.config';
import _ from 'underscore';

import FormInput from './form';

import BulkImport from './component/bulk';
import SingleInput from './component/single';
import TableImport from './component/tabel.import';
import FormBulkUpdate from './component/form';

const initialState = {
  privilege: null,
  isShow: false,
  imports: [],
  update: null,
  types: null, // single or bulk_import
};

const SettingServiceScreen = () => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateForm = useSelector((state) => state.Form);
  const ServiceTable = useTable('service_type', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['service_type']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ isShow, privilege, imports, update, types }, setState] =
    React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isShow: false,
      imports: [],
      update: null,
      types: null,
    }));
  };

  const $resetTable = async () => {
    $handleClose();
    Dispatch(Table.$reload('service_type', StateTable));
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.service',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  const $handleUpdate = async (d, id) => {
    const u = { id: id, data: imports[id] };
    setState((prevState) => ({
      ...prevState,
      update: u,
    }));
  };

  const $handleDelete = async (id) => {
    let newList = [...imports];
    newList.splice(id, 1);
    setState((prevState) => ({
      ...prevState,
      imports: newList,
      update: null,
    }));
  };

  const $onUpdate = async (d) => {
    let newList = [...imports];
    newList[update?.id] = d;

    setState((prevState) => ({
      ...prevState,
      imports: newList,
      update: null,
    }));
  };

  const $handleSubmit = async (c) => {
    let datas = [];

    _.map(imports, function (d) {
      let forms = {
        service_id: d?.service?.id,
        name: d?.name,
        pricing_schema: d?.pricing_schema,
        min_weight: d?.min_weight || 1,
        dividers: d?.dividers,
      };

      datas?.push(forms);
    });

    const req = await Dispatch(Services.$createBulkType({ datas: datas }));

    if (req?.message === 'success') {
      $resetTable();
    }
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <div className="sub-page">
      <div className="sub-page-navigation">
        <ServiceTable.Tools downloadable>
          {(!Session?.privileges || privilege?.action === 'manage') && (
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">
                Tambah Layanan Baru
              </span>
            </button>
          )}
        </ServiceTable.Tools>
      </div>
      <div className="sub-page-body">
        {StateLoading ? (
          <SkeletonTable headerCount={6} bodyCount={10} />
        ) : (
          <ServiceTable.Render />
        )}
      </div>
      <div className="sub-page-footer">
        {StateLoading ? <SkeletonPageFooter /> : <ServiceTable.Pagination />}
      </div>

      <Modal
        show={isShow}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="xl"
        scrollable
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Buat Tipe Layanan</Modal.Title>
        </Modal.Header>
        {(types === null ||
          (types === 'bulk_import' && imports?.length) === 0) && (
          <div className="row border bg-white m-0">
            <div className="col-md-5 border-bottom-sm d-flex justify-content-center align-items-center">
              <BulkImport
                onImported={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    imports: [...prevState?.imports, e],
                    types: 'bulk_import',
                    update: null,
                  }))
                }
              />
            </div>
            <div className="col-md-2 d-flex justify-content-center align-items-center  position-relative">
              <div
                className="position-absolute top-50 start-50 translate-middle d-none d-md-flex"
                style={{
                  height: 150,
                  width: 0.5,
                  backgroundColor: '#848484',
                }}
              />
              <div
                className="rounded-circle bg-white d-flex justify-content-center align-items-center fs-8 text-uppercase fw-bold text-grey"
                style={{
                  width: 70,
                  height: 70,
                  zIndex: 9,
                  border: '1px solid #848484',
                }}
              >
                atau
              </div>
            </div>
            <div className="col-md-5  d-flex justify-content-center align-items-center">
              <SingleInput
                onPress={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    types: 'single',
                    imports: [],
                    update: null,
                  }))
                }
              />
            </div>
          </div>
        )}

        {types === 'bulk_import' && imports?.length > 0 && (
          <>
            <Modal.Body>
              {update ? (
                <FormBulkUpdate
                  data={update?.data}
                  onSubmit={$onUpdate}
                  onClose={() => {
                    setState((prevState) => ({ ...prevState, update: null }));
                  }}
                />
              ) : null}

              <div className="mt-3">
                <TableImport
                  data={imports}
                  onDelete={$handleDelete}
                  onUpdate={$handleUpdate}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="row w-100">
                <div className="col">
                  <Button
                    type="button"
                    className="btn btn-light w-100"
                    onClick={$handleClose}
                  >
                    Batal
                  </Button>
                </div>
                <div className="col">
                  <Button
                    type="button"
                    className={cn(
                      StateForm?.loading ? 'btn-loading' : '',
                      'btn btn-primary w-100'
                    )}
                    disabled={StateForm?.loading}
                    onClick={$handleSubmit}
                  >
                    Simpan
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </>
        )}

        {types === 'single' && (
          <FormInput
            onClose={() => {
              $handleClose();
            }}
          />
        )}
      </Modal>
    </div>
  );
};

export default SettingServiceScreen;
